export enum ButtonType {
	primary = 'primary',
	secondary = 'secondary',
	tertiary = 'tertiary',
	caution = 'caution',
	special = 'special',
};

/* - Primary and Secondary refer to the mono types in Figma
 * - Officially there's also visited, which is omitted here
 * - "pressed" is not an official state, defined here like "active"
 * - "special" is not an official variant/type and product specific
 */
const stateMap = {
	'primary': {
		'all': 'border-button outline-offset-4 rounded-full',
		'stateless': 'bg-button-primary-bg border-button-primary-border text-white',
		'hover': 'hover:bg-button-primary-hover-bg hover:border-button-primary-hover-border hover:text-white',
		'active': 'active:bg-button-primary-active-bg active:border-button-primary-active-border active:text-white',
		'focus': 'focus:outline-button-focus-outline',
		'pressed': 'bg-button-primary-bg border-button-primary-border text-white',
		'disabled': 'bg-button-primary-disabled-bg border-button-primary-disabled-border text-white cursor-default',
		'disabled-pressed': 'bg-button-primary-disabled-bg border-button-primary-disabled-border text-white cursor-default',
	},
	'secondary': {
		'all': 'border-button outline-offset-4 rounded-full',
		'stateless': 'bg-button-secondary-bg border-button-secondary-border text-button-secondary-text',
		'hover': 'hover:bg-button-secondary-hover-bg hover:border-button-secondary-hover-border hover:text-button-secondary-hover-text',
		'active': 'active:bg-button-secondary-active-bg active:border-button-secondary-active-border active:text-button-secondary-active-text',
		'focus': 'focus:outline-button-focus-outline',
		'pressed': 'bg-button-secondary-active-bg border-button-secondary-active-border text-button-secondary-active-text',
		'disabled': 'bg-button-secondary-disabled-bg border-button-secondary-disabled-border text-button-secondary-disabled-text cursor-default',
		'disabled-pressed': 'bg-button-secondary-disabled-bg border-button-secondary-disabled-border text-button-secondary-disabled-text cursor-default',
	},
	'tertiary': {
		'all': 'border-button outline-offset-4 rounded-full',
		'stateless': 'bg-button-tertiary-bg border-button-tertiary-border text-button-tertiary-text',
		'hover': 'hover:bg-button-tertiary-hover-bg hover:border-button-tertiary-hover-border hover:text-button-tertiary-hover-text',
		'active': 'active:bg-button-tertiary-active-bg active:border-button-tertiary-active-border active:text-button-tertiary-active-text',
		'focus': 'focus:outline-button-focus-outline',
		'pressed': 'bg-button-tertiary-active-bg border-button-tertiary-active-border text-button-tertiary-active-text',
		'disabled': 'bg-transparent border-button-tertiary-disabled-border cursor-default text-button-tertiary-disabled-text',
		'disabled-pressed': 'bg-button-tertiary-disabled-bg border-button-tertiary-disabled-border cursor-default text-button-tertiary-disabled-text',
	},
	'caution': {
		'all': 'border-button rounded-full',
		'stateless': 'border-button-caution-border text-button-caution-text outline-offset-4',
		'hover': 'hover:bg-button-caution-hover-bg hover:border-button-caution-hover-border hover:text-button-caution-hover-text',
		'active': 'active:bg-button-caution-active-bg active:border-button-caution-active-border active:text-button-caution-active-text',
		'focus': 'focus:outline-button-focus-outline',
		'pressed': 'bg-transparent border-button-caution-border text-button-caution-text',
		'disabled': 'bg-button-caution-disabled-bg border-button-caution-disabled-border text-button-caution-disabled-text cursor-default',
		'disabled-pressed': 'bg-button-caution-disabled-bg border-button-caution-disabled-border text-button-caution-disabled-text cursor-default',
	},
	'special': {
		'all': 'border-button bg-button-special-bg border-button-special-border text-button-special-text rounded-full',
		'stateless': 'outline-offset-4',
		'hover': 'hover:bg-button-special-hover-bg hover:border-button-special-hover-border',
		'active': 'active:bg-button-special-active-bg active:border-button-special-active-border',
		'focus': 'focus:outline-button-focus-outline',
		'pressed': 'bg-button-special-active-bg border-button-special-active-border',
		'disabled': 'cursor-default',
		'disabled-pressed': 'cursor-default',
	},
};

export const stateClassBuilder = (type: ButtonType, disabled: boolean, pressed: boolean): string => {
	if (pressed && type == ButtonType.caution) {
		console.warn(`Button type ${type} with state pressed is not valid`);
	}

	return [
		stateMap[type]['all'] ?? '',
		!disabled && !pressed ? stateMap[type]['stateless'] : '',
		!disabled && !pressed ? stateMap[type]['hover'] : '',
		!disabled && !pressed ? stateMap[type]['active'] : '',
		!disabled ? stateMap[type]['focus'] : '',
		disabled && !pressed ? stateMap[type]['disabled'] : '',
		pressed && !disabled ? stateMap[type]['pressed'] : '',
		pressed && disabled ? stateMap[type]['disabled-pressed'] : '',
	].join(' ');
}
